<div class="layout-wrapper">
  <div class="layout-main layout-fullscreen">
    <div class="layout-content flex flex-column mt-2">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
